import type { Season } from '@protector/entities/season/models';
import type { CustomFormTimelineRecord } from '@protector/entities/timeline/models';
import { isActive } from '@protector/entities/season/utils';
import { EventType, type TimelineWindow } from './timeline.models';

export const sanitizeTimelineWindowEvents = (timelineWindow: TimelineWindow[]) => {
  const windowsWithEvents = timelineWindow.filter(w => w.events.length > 0);

  return windowsWithEvents.map(window => {
    const hasBothEventTypes = window.events.includes(EventType.SCOUTING_MONITORING) && window.events.includes(EventType.MONITORING);

    const eventToRemove = hasBothEventTypes ? EventType.SCOUTING_MONITORING : EventType.MONITORING;
    const filteredEvents = window.events.filter(event => event !== eventToRemove);

    return {
      ...window,
      events: filteredEvents
    };
  });
};

export const mergeCustomFormTimelineEvents = (
  windows: TimelineWindow[],
  records: CustomFormTimelineRecord[],
  companyId: string,
  propertyId: string,
  fieldId: string
): TimelineWindow[] => {
  const merged = windows.map(window => ({ ...window, events: [...window.events] }));
  for (const record of records) {
    if (record.org_id !== companyId || record.property_id !== propertyId || record.field_id !== fieldId) continue;
    const timestamp = Date.parse(record.reference_date);
    if (!Number.isFinite(timestamp)) continue;
    const date = new Date(timestamp).toISOString().slice(0, 10);
    const existing = merged.find(window => date >= window.start_date.slice(0, 10) && date <= window.end_date.slice(0, 10));
    if (existing) {
      if (!existing.events.includes(EventType.CUSTOM_FORM)) existing.events.push(EventType.CUSTOM_FORM);
      continue;
    }
    merged.push({ start_date: date, end_date: date, events: [EventType.CUSTOM_FORM], phenological_stage: '' });
  }
  return merged.sort((left, right) => right.start_date.localeCompare(left.start_date));
};

export const isShowLayers = ({ allSeasons, selectedSeasons }: { allSeasons?: Season[]; selectedSeasons: string[] }) => {
  return allSeasons
    ? selectedSeasons.some(seasonId => {
        const season = allSeasons.find(sea => sea.id === seasonId);
        return season && isActive(season);
      })
    : true;
};
